import { render, staticRenderFns } from "./DishComponent.vue?vue&type=template&id=6b7b63ba&scoped=true&"
import script from "./DishComponent.vue?vue&type=script&lang=ts&"
export * from "./DishComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DishComponent.vue?vue&type=style&index=0&id=6b7b63ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b63ba",
  null
  
)

export default component.exports